import React, { useEffect, useState } from 'react'
import RouteMenu from 'NOTICEBOARD/CommonResources/RoutingMenu/RouteMenu';
import 'NOTICEBOARD/Components/Reports/Reports.css'
import { BarChart, Close, FilterAltOutlined, Refresh } from '@mui/icons-material';
import DepartmentNoticeCount from './DeprtmentNoticeCount/DeprtmentNoticeCount';
import DepartmentNoticeList from './DepartmentNoticeList/DepartmentNoticeList';
import NoticeListReport from './NoticeListReport/NoticeListReport';
import SemesterNoticeList from './SemesterNoticeList/SemesterNoticeList';

function Reports(props) {

    useEffect(()=>{
        if (props.match.params.id != 'allReports') {
            document.getElementById('header').style.display = "none"
            document.getElementById('footer').style.display = "none"
        } else {
            document.getElementById('header').style.display = "flex";
        }
    },[])

    // if(props.match.path.includes('reports') && props.match.params.id != 'allReports'){
    //     document.getElementById('header').style.display = "none" 
    //     document.getElementById('footer').style.display = "none" 
    // }else {
    //     // document.getElementById('header').style.display = "flex";
    // }

    // all states
    const [reportDetails, setReportDetails] = useState([
        {
            reportName: 'Department wise Notice Count Report',
            reportCode: 'departmentNoticeCount'
        }, 
        {
            reportName: 'Department wise Notice List Report',
            reportCode: 'departmentNoticeList'
        }, 
        {
            reportName: 'Notices List Report',
            reportCode: 'noticeList'
        }, 
        {
            reportName: 'Semester wise Notice List Report',
            reportCode: 'semesterNoticeList'
        }
    ]);
    const [currentReport, setCurrentReport] = useState('');
    const [currentReportType, setCurrentReportType] = useState('');
    const [viewReport, setViewReport] = useState(false);


    // all onchange and onclick methods
    const closeViewReport = () => {
        setViewReport(false);
    }

    const viewCurrentReport = (report) => {
        setViewReport(true);
        setCurrentReport(report.reportName);
        setCurrentReportType(report.reportCode);
    }

    const returnViewReport = () => {
        return <div className="modal fade show" id="modalContainer" >
            <div className="modal-dialog modal-dialog-centered h-75 reportModalDialog">
                <div className="h-100 modal-content">
                    <div className="modal-header d-flex text-center p-2" style={ { backgroundColor: '#0465ac' } } >
                        <div className=" flex-grow-1">
                            <h5 className="modal-title text-white">{currentReport}</h5>
                        </div>
                        <div className="">
                            <Close style={ { color: 'white', cursor: 'pointer' } } onClick={() => closeViewReport()} />
                        </div>
                    </div>
                    <div className="h-100 bodyBackgroundColor scrollController" style={ { overflow: 'auto' } }>
                        {
                            currentReportType == 'departmentNoticeCount' &&
                                <DepartmentNoticeCount />
                        }
                        {
                            currentReportType == 'departmentNoticeList' &&
                                <DepartmentNoticeList />
                        }
                        {
                            currentReportType == 'noticeList' &&
                                <NoticeListReport />
                        }
                        {
                            currentReportType == 'semesterNoticeList' &&
                                <SemesterNoticeList />
                        }
                    </div>
                </div>
            </div>
        </div>
    }

    // METHOD TO RETURN REPORT WITH IDS
    const returnReportDetails = () => {
        if(props.match.params.id == 0){
            return (
                <DepartmentNoticeCount />
            );
        }else if(props.match.params.id == 1){
            return (
                <DepartmentNoticeList />
            );
        }else if(props.match.params.id == 2){
            return (
                <NoticeListReport />
            );
        }else if(props.match.params.id == 3){
            return (
                <SemesterNoticeList /> 
            );
        }else{
            return(
                <div className="invalidReport-container">
                    <p className="invalid-report-message">Invalid Report</p>
                </div>
            );
        }
    }

    return (
        <>
            {
                props.match.params.id == 'allReports' ?
                    <>
                        <div className="sideMenu" style={ { padding: 0 } }>
                            <RouteMenu activeScreen="reports" />
                        </div>
                        <div className="reportsTab">
                            <div className='reportsDiv'>
                                <div className='col-md-12'>
                                    <h4>Reports</h4>
                                </div>
                                <div className='row'>
                                    { reportDetails.map((report) =>
                                        <div className='reportsCardDiv col-md-3 col-sm-12'>
                                            <div className='reportsCard reportsCardTitle'>
                                                <div className='text-left w-100'>{report.reportName}</div>
                                                <div className='reportsCardButtonDiv'>
                                                    <div></div>
                                                    <button
                                                        type="button"
                                                        className="btn py-1 viewReportButton" 
                                                        onClick={ () => viewCurrentReport(report) }
                                                    >View Report
                                                    </button></div>
                                            </div>
                                        </div>
                                    ) }
                                </div>
                            </div>
                        </div>

                        {/* modal for reports */ }
                        {
                            viewReport && 
                                returnViewReport()
                        }
                    </>
                :
                    returnReportDetails()
            }
        </>
    )
}

export default Reports